import React from "react";
import B2BNav from "./B2BNav";
import B2BHero from "./B2BHero";
import B2BSections from "./B2BSections";
import B2BFooter from "./B2BFooter";
import "./b2b.css";

const Landing = () => {
  return (
    <div className="b2b-wrapper">
      <B2BNav />
      <B2BHero />
      <B2BSections />
      <B2BFooter />
    </div>
  );
};

export default Landing;
